<template>
  <div class="wrap">
    <div class="WordSection1" style="layout-grid: 15.6pt">
      <h3 class="MsoNormal " align="left" style="text-align: left; line-height: 20pt; layout-grid-mode: char">
        <b
        ><span style="font-family: 宋体">
          声明：使用本网站前请您务必仔细阅读以下条款。一旦使用本网站则表明您已明知并接受这些条款。</span
        ></b
        >
      </h3>

      <ul style="margin-top: 0cm" type="disc">
        <h3
          class="MsoNormal"
          style="
            margin-bottom: 7.5pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <b><span style="font-family: 宋体">一、网站的使用</span></b>
        </h3>
      </ul>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体"
        >网站上的内容，无论是您免费试听的课程还是您付费购买的课程，仅供您个人而非商业用途的使用。对于内容中所含的知识产权和其他所有权声明，您应予以尊重并合法使用。如果网站内容无权利声明，并不代表网站对其不享有权利，也不意味着网站不主张权利，您应根据诚信原则尊重该等内容的合法权益并进行合法使用。您不得以任何方式修改、复制、公开展示、公布或分发这些视频及资料或者以其他方式把它们用于任何公开或商业目的。禁止以任何目的把这些视频及资料用于其他任何网站或其他平面媒体或网络计算机环境。本站上的内容及编辑等形式均受版权法等法律保护，任何未经授权而使用本网站材素材的行为都可能构成对版权和其他法律权利的侵犯。本网站及相关链接网站上使用和显示的商标、服务商标和标识（以下统称<span
          lang="EN-US"
        >"</span
        >商标<span lang="EN-US">"</span
        >）是属于厦门铸远教育科技有限公司及其他权利主体的。您使用或接触该等网站上的任何内容，不能被解释为授予您任何使用有关商标的权利。</span
        >
      </p>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体">如果您不接受或违反上述约定，您使用本站的授权将自动终止，同时您应立即销毁任何已下载或打印好的本站内容。</span
        >
      </p>

      <ul style="margin-top: 0cm" type="disc">
        <h3
          class="MsoNormal"
          style="
            margin-bottom: 7.5pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <b><span style="font-family: 宋体">二、信息和资料发布</span></b>
        </h3>
      </ul>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体">本站的信息和资料由老师个人提供，本网站不负责审核，也不附加任何形式的保证，包括准确性、真实性和不侵犯知识产权等的保证。您在使用此类信息和资料，须经过合理审慎的查询和判断。</span
        >
      </p>

      <ul style="margin-top: 0cm" type="disc">
        <h3
          class="MsoNormal"
          style="
            margin-bottom: 7.5pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <b><span style="font-family: 宋体">三、用户交流内容</span></b>
        </h3>
      </ul>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体">本机构不负责监控或审查用户在本站上的留言或相互之间单独交流的任何领域中的信息，包括但不限于留言板、公告牌或其他用户论坛以及任何交流内容。本机构对有关任何这类交流的内容不承担任何责任，无论它们是否会引起诽谤、侵犯隐私、淫秽或其它方面的问题。本机构保留在发现时删除此类信息或包含其它不良内容的信息的权利。</span
        >
      </p>

      <ul style="margin-top: 0cm" type="disc">
        <h3
          class="MsoNormal"
          style="
            margin-bottom: 7.5pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <b><span style="font-family: 宋体">四、本站下载软件的使用</span></b>
        </h3>
      </ul>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体">如果您从本站下载软件，在使用软件时要遵守该软件附带的软件许可协议中所有的许可条款。在您阅读并接受软件许可协议的各项条款之前，不得下载或安装这一软件。如果在适用的许可条款或协议中，已经禁止复制或再分发这些软件，您须遵照执行。</span
        >
      </p>

      <ul style="margin-top: 0cm" type="disc">
        <h3
          class="MsoNormal"
          style="
            margin-bottom: 7.5pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <b><span style="font-family: 宋体">五、链接第三方网站</span></b>
        </h3>
      </ul>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体"
        >本站到第三方网站的链接仅作为一种方便服务提供给您。如果使用这些链接，您将离开本站。本机构没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何责任。如果您决定访问任何与本站链接的第三方网站，其可能带来的结果和风险全部由您自己承担。</span
        >
      </p>

      <ul style="margin-top: 0cm" type="disc">
        <h3
          class="MsoNormal"
          style="
            margin-bottom: 7.5pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <b><span style="font-family: 宋体">六、责任承担</span></b>
        </h3>
      </ul>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体"
        >对于其他网址链接在本网址的内容，本机构概不负法律责任。在法律允许的最大限度内，本机构保留随时暂停或撤销整个网站或网站任何一部分的权利，而无需另行通知或承担任何责任。</span
        >
      </p>

      <ul style="margin-top: 0cm" type="disc">
        <h3
          class="MsoNormal"
          style="
            margin-bottom: 7.5pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <b><span style="font-family: 宋体">七、安全规则</span></b>
        </h3>
      </ul>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体"
        >禁止使用者破坏或企图破坏本机构的安全规则，其中包括但不限于<span lang="EN-US">:</span></span
        >
      </p>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体"
        >（<span lang="EN-US">1</span>）伪造<span lang="EN-US">TCP/IP</span>数据包名称或部分名称。</span
        >
      </p>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体"
        >（<span lang="EN-US">2</span>）接触未经许可的数据或进入未经许可的服务器或帐户；</span
        >
      </p>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体"
        >（<span lang="EN-US">3</span>）企图干涉对用户及网络的服务，包括，并不限于，通过超载，<span lang="EN-US">
          "</span
        >邮件炸弹<span lang="EN-US">"</span>或<span lang="EN-US">"</span>摧毁<span lang="EN-US">"</span>等手段；</span
        >
      </p>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体">（<span lang="EN-US">4</span>）发送促销，产品广告及服务的<span lang="EN-US">E-mail</span>；</span
        >
      </p>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体">（<span lang="EN-US">5</span>）没有得到许可，企图探查，扫描或测试系统或网络的弱点，或者破坏安全措施。</span
        >
      </p>

      <ul style="margin-top: 0cm" type="disc">
        <h3
          class="MsoNormal"
          style="
            margin-bottom: 7.5pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <b><span style="font-family: 宋体">八、一般原则</span></b>
        </h3>
      </ul>

      <p
        class="MsoNormal"
        align="left"
        style="
          margin-left: 36pt;
          text-align: left;
          line-height: 20pt;
          layout-grid-mode: char;
        "
      >
        <span style="font-family: 宋体"
        >本机构可能随时修改这些条款。您应经常访问本页面以了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被本站中某些页面上明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。</span
        >
      </p>

      <ul style="margin-top: 0cm" type="disc">
        <li
          class="MsoNormal"
          style="
            margin-top: 48.75pt;
            text-align: left;
            line-height: 20pt;
            layout-grid-mode: char;
          "
        >
          <span style="font-family: 宋体"
          >警告： 使用本机构网络时违反本条款将构成对本机构权利的侵害，本机构将保留采取一切法律措施的权利。</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.wrap {
  h3 {
    margin: 20px 0;
    font-size: 20px;
    color: #333333;
  }
  .top {
    margin: 0 0 20px 0;
  }
  p {
    font-size: 16px;
    color: #333333;
    margin: 5px 0;
    /* padding: 5px 0; */
  }
  span {
    margin: 10px 0;
  }
}
</style>
